import {ValueObject} from '@s-ui/domain'

export default class ScreensetValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} params
   * @param {String} params.screenset // One of: 'login-mt', 'register-mt', 'forgot-password-mt', 'reset-password-mt'
   */
  constructor({screenset}) {
    super({screenset})
  }

  /**
   * @return {String}
   */
  getScreenset() {
    return this._screenset
  }
}
